import { CONNECTOR_SUBTYPES, CONNECTOR_TYPES } from '../../../api/Connectors/Connectors';

export default [
  {
    name: 'EJEMPLO1_FTP',
    type: CONNECTOR_TYPES.FTP,
    subtype: CONNECTOR_SUBTYPES.VECTOR,
    ip: '192.168.1.43',
    port: 30018,
    user: 'admin_maps',
    password: 'srm-d01',
    fileType: 'GeoJSON',
    filePath: '/result.geojson'
  },
  {
    name: 'EJEMPLO1_POSTGRESSQL',
    type: CONNECTOR_TYPES.POSTGRESQL,
    subtype: CONNECTOR_SUBTYPES.VECTOR,
    ip: '192.168.1.43',
    port: 30030,
    user: 'srm_postgres_1',
    password: 'pg_produccion#1',
    databaseName: 'imetadata',
    schema: 'multinivel'
  },
  {
    name: 'EJEMPLO2_POSTGRESSQL',
    type: CONNECTOR_TYPES.POSTGRESQL,
    subtype: CONNECTOR_SUBTYPES.VECTOR,
    ip: '192.168.1.43',
    port: 30030,
    user: 'srm_postgres_1',
    password: 'pg_produccion#1',
    databaseName: 'imetadata',
    schema: 'multinivel'
  },
  {
    name: 'EJEMPLO1_HTTP',
    type: CONNECTOR_TYPES.HTTP,
    subtype: CONNECTOR_SUBTYPES.THEMATIC,
    domain: 'www.dropbox.com',
    fileType: 'CSV',
    filePath: '/s/otebu94y5yffeal/csv_aleatorio.csv'
  }
];
